// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";

// const AddHomeWorkPricing = () => {
//   const [schoolClassName, setSchoolClassName] = useState([]);
//   const [schoolClassNameId, setSchoolClassNameId] = useState();
//   const [price, setPrice] = useState();

//   const navigate = useNavigate();
//   const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

//   // CLASSES DATA GET FUN AXIOS --
//   const getClasses = () => {
//     axios
//       .get(`${API_BASE_URL}/classes`)
//       .then((resp) => {
//         const { data } = resp.data;
//         setSchoolClassName(data);
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   };
//   useEffect(() => {
//     getClasses();
//   }, []);
//   const handleAddNewHomeWorkPricing = () => {
//     navigate("/add-home-work-pricing");
//   };
//   const handleViewAllHomeWorkPricing = () => {
//     navigate("/all-home-work-pricing");
//   };
//   const payload = {
//     classId: schoolClassNameId,
//     price,
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     axios
//       .post(`${API_BASE_URL}/admin/pricing/home-work`, payload, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       })
//       .then((result) => {
//         console.log(result);
//         alert("Price Added Successfully.");
//         navigate("/all-home-work-pricing");
//       })
//       .catch((error) => {
//         console.log(error);
//         alert("Error while adding Price");
//       });
//   };
//   return (
//     <>
//       <div id="add-subject-inner-wrapper">
//         <div className="superheader">
//           <div className="subjectHeaderdiv">
//             <h5>Add Home Work Pricing</h5>
//             <div className="subjectdiv2">
//               <button
//                 className="handleNewSubject"
//                 onClick={handleAddNewHomeWorkPricing}
//               >
//                 + Add New Pricing
//               </button>
//               <button
//                 className="allSubjects"
//                 onClick={handleViewAllHomeWorkPricing}
//               >
//                 All Pricing
//               </button>
//             </div>
//           </div>

//           <div className="form-sub-container mt-4" id="form">
//             <h4 className="subject-detail">Home Work Pricing</h4>
//             <form
//               className="subject-detail-form"
//               encType="multipart/form-data"
//               onSubmit={handleSubmit}
//             >
//               <div className="input-group">
//                 <div style={{ paddingBottom: "10px" }}>
//                   <label className="label">Class Name</label>
//                 </div>
//                 <select
//                   className="select-dropdown"
//                   value={schoolClassNameId}
//                   onChange={(e) => setSchoolClassNameId(e.target.value)}
//                   required
//                 >
//                   <option value="">-Select Class</option>
//                   {schoolClassName &&
//                     schoolClassName.slice(0, 8).map((classes) => (
//                       <option value={classes._id} key={classes._id}>
//                         {classes?.className}
//                       </option>
//                     ))}
//                 </select>
//               </div>

//               <div className="input-group">
//                 <div style={{ paddingBottom: "10px" }}>
//                   <label className="label">Price</label>
//                 </div>
//                 <input
//                   type="text"
//                   placeholder="Enter Price"
//                   value={price}
//                   onChange={(e) => setPrice(e.target.value)}
//                   required
//                 />
//               </div>

//               <div className="school-subj-form-btns">
//                 <button
//                   className="btn-search"
//                   type="submit"
//                   // onClick={handleSubmit}
//                 >
//                   Save
//                 </button>
//                 <button className="btn-cancel">Cancel</button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default AddHomeWorkPricing;



import axios from "axios";
import React, { useEffect, useState } from "react";

const AddHomeWorkPricing = () => {

  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const [classes, setClasses] = useState([]);
  const [pricing, setPricing] = useState([]);

  const [classId, setClassId] = useState("");

  const [trialEnabled, setTrialEnabled] = useState(true);
  const [trialDays, setTrialDays] = useState(7);

  const [plans, setPlans] = useState({
    1: "",
    3: "",
    6: "",
    12: ""
  });

  const [editMode, setEditMode] = useState(false);

  /* ---------------- GET CLASSES ---------------- */

  const getClasses = async () => {
    try {
      const resp = await axios.get(`${API_BASE_URL}/classes`);
      setClasses(resp.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  /* ---------------- GET PRICING ---------------- */

  const getPricing = async () => {
    try {
      const resp = await axios.get(`${API_BASE_URL}/homework-priceall`);
      setPricing(resp.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getClasses();
    getPricing();
  }, []);

  /* ---------------- HANDLE PLAN CHANGE ---------------- */

  const handlePlanChange = (duration, value) => {
    setPlans(prev => ({
      ...prev,
      [duration]: value
    }));
  };

  /* ---------------- SUBMIT ---------------- */

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      const token = localStorage.getItem("token");

      const subscriptionOptions = Object.keys(plans)
        .filter(d => plans[d])
        .map(d => ({
          duration: Number(d),
          price: Number(plans[d])
        }));

      const payload = {
        classId,
        subscriptionOptions,
        trialEnabled,
        trialDays
      };

      await axios.post(
        `${API_BASE_URL}/admin/homework-price`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      alert("Pricing saved successfully");

      resetForm();
      getPricing();

    } catch (error) {
      console.log(error);
      alert("Error saving pricing");
    }
  };

  /* ---------------- EDIT ---------------- */

  const handleEdit = (item) => {

    setEditMode(true);
    setClassId(item.classId?._id);

    const newPlans = { 1: "", 3: "", 6: "", 12: "" };

    item.subscriptionOptions.forEach(p => {
      newPlans[p.duration] = p.price;
    });

    setPlans(newPlans);
    setTrialEnabled(item.trialEnabled);
    setTrialDays(item.trialDays);
  };

  /* ---------------- DELETE ---------------- */

  const handleDelete = async (id) => {

    if (!window.confirm("Delete this pricing?")) return;

    try {

      const token = localStorage.getItem("token");

      await axios.delete(
        `${API_BASE_URL}/admin/pricing/home-work/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      alert("Deleted successfully");

      getPricing();

    } catch (error) {
      console.log(error);
    }
  };

  /* ---------------- RESET ---------------- */

  const resetForm = () => {
    setClassId("");
    setPlans({ 1: "", 3: "", 6: "", 12: "" });
    setTrialEnabled(true);
    setTrialDays(7);
    setEditMode(false);
  };

  return (
    <div style={{ padding: "20px" }}>

      <h2>Homework Assistance Pricing</h2>

      {/* FORM */}

      <form onSubmit={handleSubmit}>

        <div>
          <label>Class</label>
          <select
            value={classId}
            onChange={(e) => setClassId(e.target.value)}
            required
          >
            <option value="">Select Class</option>

            {classes.map(c => (
              <option key={c._id} value={c._id}>
                {c.className}
              </option>
            ))}

          </select>
        </div>

        <h4>Subscription Plans</h4>

        {[1, 3, 6, 12].map(duration => (

          <div key={duration}>
            <label>{duration} Month Price</label>
            <input
              type="number"
              value={plans[duration]}
              onChange={(e) =>
                handlePlanChange(duration, e.target.value)
              }
            />
          </div>

        ))}

        <h4>Trial Settings</h4>

        <div>
          <label>Enable Trial</label>
          <input
            type="checkbox"
            checked={trialEnabled}
            onChange={(e) => setTrialEnabled(e.target.checked)}
          />
        </div>

        <div>
          <label>Trial Days</label>
          <input
            type="number"
            value={trialDays}
            onChange={(e) => setTrialDays(e.target.value)}
          />
        </div>

        <br />

        <button type="submit">
          {editMode ? "Update Pricing" : "Save Pricing"}
        </button>

        <button type="button" onClick={resetForm}>
          Reset
        </button>

      </form>

      {/* TABLE */}

      <h3 style={{ marginTop: "40px" }}>Existing Pricing</h3>

      <table border="1" width="100%" cellPadding="10">

        <thead>
          <tr>
            <th>Class</th>
            <th>Plans</th>
            <th>Trial</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>

          {pricing.map(item => (

            <tr key={item._id}>

              <td>{item.classId?.className}</td>

              <td>
                {item.subscriptionOptions.map(p => (
                  <div key={p.duration}>
                    {p.duration} Month → ₹{p.price}
                  </div>
                ))}
              </td>

              <td>
                {item.trialEnabled
                  ? `${item.trialDays} Days`
                  : "Disabled"}
              </td>

              <td>

                <button
                  onClick={() => handleEdit(item)}
                >
                  Edit
                </button>

                <button
                  onClick={() => handleDelete(item._id)}
                  style={{ marginLeft: "10px", color: "red" }}
                >
                  Delete
                </button>

              </td>

            </tr>

          ))}

        </tbody>

      </table>

    </div>
  );
};

export default AddHomeWorkPricing;